import { formatPhoneNumberForApi } from '../utils/formatNumber';

export class DialogSaveAdapter {
    constructor(data) {
        this.newData = { ...data };

        const transformations = {
            phone: () => {
                const { phone, ...restData } = this.newData;

                let formattedPhone = '';
                console.log('phone before format:', phone);
                if (Array.isArray(phone)) {
                    formattedPhone = phone
                        .filter(Boolean)
                        .map((p) => formatPhoneNumberForApi(p));
                } else if (typeof phone === 'string') {
                    formattedPhone = formatPhoneNumberForApi(phone);
                }

                this.newData = {
                    ...restData,
                    phone: formattedPhone
                };
            },
            phoneNumber: () => {
                const { phone, ...restData } = this.newData;
                this.newData = restData;
                this.newData.phone = phone
                    ? formatPhoneNumberForApi(phone)
                    : '';
            },
            role: () => {
                const { role, ...restData } = this.newData;
                this.newData = restData;
                this.newData.roleId = role?.id || null;
            }
        };

        for (const prop in this.newData) {
            if (transformations[prop]) {
                transformations[prop]();
            }
        }
    }
}
